import { useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Tooltip } from "@mui/material";
import Popover from "@mui/material/Popover";

import RibbonElementCommon from "./RibbonElementCommon.jsx";

const RibbonElementSelect = ({ elementSettings }) => {
	const { name, _children, icon, isDisabled, nameVisible, size, callback, allowSelfCallback } = elementSettings;
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<div className="ribbon-element-select-wrapper">
			<Tooltip title={nameVisible && name}>
				<span>
					<button
						className={size === "large" ? "ribbon-element-select ribbon-element-select__large" : "ribbon-element-common"}
						disabled={isDisabled}
						onClick={(e) => {
							if (allowSelfCallback) {
								if (e?.target?.tagName === "path") {
									handleClick(e);
								} else if (e?.target?.tagName === "svg") {
									if (e?.target?.getAttribute("data-testid") === "ArrowDropDownIcon") {
										handleClick(e);
									} else {
										callback();
									}
								} else {
									callback();
								}
							} else {
								handleClick(e);
							}
						}}
					>
						{icon}
						{!nameVisible && name}
						<ArrowDropDownIcon className={size === "large" ? "ribbon-element-select-svg__large" : ""} />
					</button>
				</span>
			</Tooltip>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				onClick={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div className="ribbon-select-options">
					{_children.map((child, index) => {
						if (child.isVisible === false) {
							return <span key={index}></span>;
						}
						return <RibbonElementCommon key={index} elementSettings={child} />;
					})}
				</div>
			</Popover>
		</div>
	);
};

export default RibbonElementSelect;
